(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  const desktop = window.matchMedia('(min-width: 1280px)');

  function syncFooterV3Menus() {
    document.querySelectorAll('[data-footer-v3-menu]').forEach((details) => {
      if (desktop.matches) {
        details.removeAttribute('name');
        details.open = true;
      } else {
        details.setAttribute('name', details.dataset.footerV3Menu);
        details.open = details.hasAttribute('data-footer-v3-default-open');
      }
    });
  }

  desktop.addEventListener('change', syncFooterV3Menus);
  syncFooterV3Menus();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-brand-values"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const homepageBrandValuesDesktop = window.matchMedia('(min-width: 1280px)');

    function openHomepageBrandValue(details) {
      const section = details.closest('.homepage-brand-values');

      section.querySelectorAll('.homepage-brand-value[open]').forEach((item) => {
        if (item !== details) item.removeAttribute('open');
      });

      details.setAttribute('open', '');
    }

    function setupHomepageBrandValues(root = document) {
      root.querySelectorAll('.homepage-brand-values').forEach((section) => {
        if (section.dataset.homepageBrandValuesBound === 'true') return;

        section.dataset.homepageBrandValuesBound = 'true';

        section.querySelector('.homepage-brand-value')?.setAttribute('open', '');

        section.addEventListener('click', (event) => {
          if (!homepageBrandValuesDesktop.matches) return;

          const target = event.target;
          if (!(target instanceof Element)) return;

          const summary = target.closest('.homepage-brand-value__summary');
          if (!summary || !section.contains(summary)) return;
          if (event.detail === 0) return;

          if (target.closest('.homepage-brand-value__title-link')) return;

          event.preventDefault();
        });

        section.addEventListener('keydown', (event) => {
          if (homepageBrandValuesDesktop.matches || event.repeat) return;
          if (event.key !== 'Enter' && event.key !== ' ') return;

          const target = event.target;
          if (!(target instanceof Element)) return;

          const summary = target.closest('.homepage-brand-value__summary');
          if (!summary || !section.contains(summary)) return;

          event.preventDefault();
          summary.click();
        });

        section.querySelectorAll('.homepage-brand-value').forEach((details) => {
          const summary = details.querySelector('.homepage-brand-value__summary');

          summary.addEventListener('mouseenter', () => {
            if (homepageBrandValuesDesktop.matches) openHomepageBrandValue(details);
          });

          details.addEventListener('focusin', () => {
            if (homepageBrandValuesDesktop.matches) openHomepageBrandValue(details);
          });

          details.addEventListener('focusout', (event) => {
            if (!homepageBrandValuesDesktop.matches || details.contains(event.relatedTarget)) return;

            details.removeAttribute('open');
          });
        });
      });
    }

    setupHomepageBrandValues();
    document.addEventListener('shopify:section:load', (event) => setupHomepageBrandValues(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mission-updates"] && !Shopify.designMode) return;
  try {
    
  class MissionUpdates extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleFilter);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.filter(this.querySelector('[data-update-filter]')?.dataset.updateFilter ?? '');
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleFilter);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    handleFilter = (event) => {
      const button = event.target.closest('[data-update-filter]');
      if (button) this.filter(button.dataset.updateFilter);
    };

    handleBlockSelect = (event) => {
      const article = event.target.closest('[data-update-category]');
      if (article && [...this.querySelectorAll('[data-update-filter]')].some((button) => button.dataset.updateFilter.trim().toLowerCase() === article.dataset.updateCategory.trim().toLowerCase())) {
        this.filter(article.dataset.updateCategory);
      }
    };

    filter(category) {
      category = category.trim().toLowerCase();
      let visible = 0;
      let selected = false;
      this.querySelectorAll('[data-update-filter]').forEach((button) => {
        const active = !selected && button.dataset.updateFilter.trim().toLowerCase() === category;
        button.setAttribute('aria-pressed', String(active));
        if (active) selected = true;
      });
      this.querySelectorAll('[data-update-category]').forEach((article) => {
        article.hidden = category !== '' && article.dataset.updateCategory.trim().toLowerCase() !== category;
        if (!article.hidden) visible += 1;
      });
      this.querySelector('.mission-updates__empty').hidden = visible > 0;
      this.querySelector('.mission-updates__list').hidden = visible === 0;
    }
  }
  if (!customElements.get('mission-updates')) customElements.define('mission-updates', MissionUpdates);

  } catch(e) { console.error(e); }
})();
})();
